import Link from 'next/link'
import { useRouter } from 'next/router'

export const BackToTraining = (): JSX.Element => {
  const router = useRouter()
  const getBackPagePath = (targetPath: string) => {
    if (router.query.selected_program) {
      targetPath += `/${router.query.selected_program}`
      if (router.query.before_page) {
        targetPath += `?page=${router.query?.before_page}`
      }
    }
    return targetPath
  }

  return (
    <Link href={getBackPagePath('/programs')}>
      <a>
        <div className="flex flex-row items-center lg:hover:opacity-50">
          <div>
            <button className="lg:w-[2.3vw] lg:h-[3vw] bg-[#F7F7F7] rounded-[4px] lg:hover:opacity-50">
              <div className="inline-block relative before:absolute before:top-0 before:left-0 before:mt-[-4px] lg:before:mt-[1.1vw] ml-[.9vw] w-full before:w-[.8vw] h-full before:h-[.8vw] before:border-t-2 before:border-r-2 before:border-[#333333] before:rotate-[-135deg]" />
            </button>
          </div>
          <div className="lg:ml-[1.2vw]">
            <div className="lg:text-[1.2vw] text-[#666666]">
              研修プログラム一覧ページへ戻る
            </div>
          </div>
        </div>
      </a>
    </Link>
  )
}
